import { TextareaAutosize, TextField } from "@mui/material";
import classNames from "classnames";
import { FC } from "react";
import styles from "./inputGroup.module.scss";

const InputGroup: FC<InputgroupPrpops> = (props: InputgroupPrpops) => {
    const { error, label, type, placeholder, onChange, value, required, labelStyle, inputStyle, disabled, errorMessage, handleFocus, handleBlur, name } = props;
    
    return <div className={styles.input_container_group}>
        {label && label !=="" && <div className={classNames(`${styles.input_label}`, labelStyle)}><div>{label}{required && <span>*</span>}</div></div>}
        {type !== "textarea" ?
            <TextField 
                name={name}
                error={error}
                fullWidth
                type={type}
                value={value}
                variant="outlined" 
                disabled={disabled}
                placeholder={placeholder}
                autoComplete={"new-password"}
                onChange={(e: any) => onChange && onChange(e.target.value)}
                onFocus={(e) => handleFocus && handleFocus(e)}
                onBlur={(e) => handleBlur && handleBlur(e)}
                className={inputStyle}
                sx={{
                    "& .Mui-disabled" : {
                        WebkitTextFillColor: disabled ? "#8FA9D1" : "rgba(0, 0, 0, 0.38)"
                    },
                    "& .MuiOutlinedInput-root" : {
                        borderColor: error ? "#EB4E4E" : ""
                    }
                }}
            /> :
            <TextareaAutosize 
                value={value} 
                placeholder={placeholder}
                onChange={(e: any) => onChange && onChange(e.target.value)}
                className={inputStyle}
            />
        }
        {
          error ? ( 
            <div className={styles.err_mess}>{errorMessage ?? "入力必須です"}</div>
          ) : (
            <></>
          )
        }
    </div>
}

export type InputgroupPrpops = {
    error?: boolean;
    label?: string;
    type: "text" | "number" | "password" | "textarea";
    placeholder?: string,
    value?: string | number;
    disabled?: boolean,
    onChange?: (val: any) => void;
    required?: boolean;
    defaultVal?: string;
    labelStyle?: string;
    inputStyle?: string;
    errorMessage?: string;
    handleFocus?: (e: any) => void;
    handleBlur?: (e: any) => void;
    name?: string
}   

export default InputGroup;